import { gql } from '@apollo/client'

export default gql(`
    mutation deleteRating($id: ID!, $scheme: String, $project: String) {
        deleteRating(
                id: $id,
                scheme: $scheme,
                project: $project
        ) {
            id
            scheme
            rating
            subRatings
        }
    }`
)
